<!--
  name : 김장호
  desc : 기업인증
  date : 2021-03-02
-->
<template>
  <v-container class="con_mpw">
    <v-row no-gutters>
      <v-col cols="12" id="myLock" class="auth_box" v-if="orgInfo">
        <v-row no-gutters class="myLock_inTxt">
          <v-col cols="12">
            <v-img></v-img>
          </v-col>
          <v-col cols="12">
            <ul class="pattern_ul_terms ta_left">
              <li>
                - 본 시스템은 <font class="fc_b00">기업 인증</font>을 통해
                전자계약시스템에서 기업의 설정 및 계약을 원활히 진행되도록
                합니다.
              </li>
              <li>
                - 계약을 체결이나 상세 조회하기 위해서는
                <font class="fc_b00">기업 인증</font>을 진행해 주십시오.
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row no-gutters class="myLock_con">
          <v-col cols="12">
            <div class="myLockCon_head">
              <div class="iconCon">
                <span class="icon"></span>
                <span class="txt">기업인증이란?</span>
              </div>
            </div>
            <div class="myLockCon_head_txt">
              <ul class="pattern_ul_terms">
                <li>
                  - <font class="fc_b00">기업인증</font>은 전자계약시스템에서
                  인증되지 않은 기업을 <u>공인인증</u>합니다.
                </li>
                <li>
                  - <font class="fc_b00">기업인증</font>을 하면 인증내역이
                  <u>전자계약시스템에 저장</u>됩니다.
                </li>
                <li>
                  - <font class="fc_b00">기업인증</font>을 통해
                  <u>기업 블록체인 비밀번호를 초기화</u>합니다.
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="myLock_inTxt">
          <v-col cols="12"> </v-col>
        </v-row>
        <v-row no-gutters class="myLock_con">
          <v-col cols="12">
            <div class="myLockCon_head">
              <div class="iconCon">
                <span class="icon"></span>
                <span class="txt"
                  >기업정보 -
                  <b
                    >{{ orgInfo ? orgInfo.organizationName : "" }} ({{
                      orgInfo
                        ? orgInfo.organizationRegistrationNumber
                        : "" | regNumFilter
                    }})</b
                  ></span
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="myLockCon_body">
              <v-form ref="passwordForm" v-model="valid" lazy-validation>
                <div class="LockCon_inPcon">
                  <div class="LockCon_inPF">
                    <div class="search_tt">블록체인 비밀번호</div>
                    <v-text-field
                      v-model="chainPass"
                      label="블록체인 비밀번호를 입력하세요."
                      :rules="rules.passwordRules"
                      single-line
                      type="password"
                    ></v-text-field>
                  </div>
                  <div class="LockCon_inPF">
                    <div class="search_tt">블록체인 비밀번호 확인</div>
                    <v-text-field
                      v-model="comfirmChainPass"
                      label="블록체인 비밀번호를 다시한번 입력하세요."
                      :rules="rules.comfirmPasswordRule"
                      single-line
                      type="password"
                    ></v-text-field>
                  </div>
                </div>

                <v-btn class="btn_myLock_issue" @click="certificate">
                  <div class="icon">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 57 57"
                      style="enable-background:new 0 0 57 57;"
                      xml:space="preserve"
                    >
                      <path
                        d="M49.5,38c0-3.859-3.14-7-7-7s-7,3.141-7,7v1h-4v18h22V39h-4V38z M37.5,38c0-2.757,2.243-5,5-5s5,2.243,5,5v1h-10V38zM51.5,41v14h-18V41h2h14H51.5z"
                      />
                      <path
                        d="M41.5,51.858V53c0,0.553,0.448,1,1,1s1-0.447,1-1v-1.142c1.72-0.447,3-1.999,3-3.858c0-2.206-1.794-4-4-4s-4,1.794-4,4C38.5,49.859,39.78,51.411,41.5,51.858z M42.5,46c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S41.397,46,42.5,46z"
                      />
                      <path
                        d="M53.354,8.51C52.197,4.22,43.578,0,28.5,0S4.803,4.22,3.646,8.51C3.562,8.657,3.5,8.818,3.5,9v0.5v12V22v11.5V34v12c0,0.161,0.042,0.313,0.115,0.448c1.139,4.833,10.691,7.68,19.811,8.364c0.025,0.002,0.051,0.003,0.076,0.003c0.519,0,0.957-0.399,0.996-0.925c0.042-0.551-0.372-1.031-0.922-1.072C12.461,51.984,5.984,48.6,5.532,45.838C5.524,45.793,5.514,45.75,5.5,45.707v-8.414c0.018,0.016,0.039,0.032,0.057,0.048c0.232,0.205,0.47,0.409,0.738,0.605C10.067,40.791,17.595,43,28.5,43c0.552,0,1-0.447,1-1s-0.448-1-1-1c-0.827,0-1.637-0.016-2.432-0.044c-0.482-0.018-0.947-0.049-1.417-0.076c-0.297-0.017-0.603-0.028-0.895-0.049c-0.624-0.045-1.23-0.103-1.829-0.165c-0.12-0.013-0.246-0.021-0.365-0.034c-0.686-0.075-1.354-0.161-2.005-0.256c-0.024-0.003-0.049-0.006-0.072-0.009c-3.379-0.499-6.279-1.26-8.548-2.165c-0.017-0.007-0.035-0.013-0.051-0.02c-0.414-0.167-0.803-0.338-1.174-0.514c-0.047-0.022-0.097-0.044-0.144-0.067c-0.333-0.16-0.64-0.325-0.935-0.491c-0.073-0.042-0.15-0.083-0.221-0.125c-0.256-0.15-0.49-0.304-0.714-0.458c-0.089-0.062-0.18-0.123-0.263-0.185c-0.188-0.139-0.358-0.28-0.52-0.421c-0.092-0.08-0.183-0.16-0.266-0.241C6.516,35.551,6.4,35.422,6.29,35.293c-0.08-0.094-0.156-0.188-0.224-0.283c-0.087-0.121-0.161-0.242-0.227-0.363c-0.055-0.101-0.104-0.202-0.146-0.303c-0.048-0.119-0.086-0.238-0.114-0.356C5.541,33.825,5.5,33.662,5.5,33.5v-8.207c0.018,0.016,0.039,0.032,0.057,0.048c0.232,0.205,0.47,0.409,0.738,0.605C10.067,28.791,17.595,31,28.5,31c10.88,0,18.396-2.199,22.177-5.034c0.29-0.212,0.55-0.431,0.799-0.653c0.008-0.007,0.017-0.014,0.024-0.021V34c0,0.553,0.448,1,1,1s1-0.447,1-1V22v-0.5v-12V9C53.5,8.818,53.438,8.657,53.354,8.51z M51.5,13.293V21.5c0,0.163-0.041,0.327-0.08,0.491c-0.028,0.117-0.065,0.233-0.112,0.351c-0.042,0.103-0.092,0.206-0.148,0.309c-0.066,0.119-0.138,0.238-0.223,0.357c-0.069,0.096-0.147,0.192-0.228,0.289c-0.108,0.127-0.223,0.254-0.353,0.38c-0.085,0.083-0.178,0.165-0.272,0.247c-0.16,0.139-0.327,0.278-0.513,0.415c-0.086,0.064-0.18,0.127-0.271,0.19c-0.222,0.153-0.453,0.305-0.706,0.453c-0.074,0.044-0.153,0.087-0.23,0.13c-0.292,0.165-0.597,0.328-0.926,0.487c-0.049,0.023-0.103,0.047-0.153,0.071c-0.369,0.174-0.754,0.345-1.166,0.51c-0.019,0.007-0.039,0.015-0.058,0.022c-2.269,0.904-5.166,1.665-8.543,2.164c-0.024,0.003-0.05,0.006-0.074,0.01c-0.651,0.095-1.318,0.181-2.003,0.256c-0.12,0.013-0.246,0.022-0.367,0.034c-0.599,0.062-1.204,0.12-1.827,0.165c-0.293,0.021-0.599,0.032-0.897,0.049c-0.469,0.027-0.934,0.059-1.416,0.076C30.137,28.984,29.327,29,28.5,29s-1.637-0.016-2.432-0.044c-0.482-0.018-0.947-0.049-1.417-0.076c-0.297-0.017-0.603-0.028-0.895-0.049c-0.624-0.045-1.23-0.103-1.829-0.165c-0.12-0.013-0.246-0.021-0.365-0.034c-0.686-0.075-1.354-0.161-2.005-0.256c-0.024-0.003-0.049-0.006-0.072-0.009c-3.379-0.499-6.279-1.26-8.548-2.165c-0.017-0.007-0.035-0.013-0.051-0.02c-0.414-0.167-0.803-0.338-1.174-0.514c-0.047-0.022-0.097-0.044-0.144-0.067c-0.333-0.16-0.64-0.325-0.935-0.491c-0.073-0.042-0.15-0.083-0.221-0.125c-0.256-0.15-0.49-0.304-0.714-0.458c-0.089-0.062-0.18-0.123-0.263-0.185c-0.188-0.139-0.358-0.28-0.52-0.421c-0.092-0.08-0.183-0.16-0.266-0.241C6.516,23.551,6.4,23.422,6.29,23.293c-0.08-0.094-0.156-0.188-0.224-0.283c-0.087-0.121-0.161-0.242-0.227-0.363c-0.055-0.101-0.104-0.202-0.146-0.303c-0.048-0.119-0.086-0.238-0.114-0.356C5.541,21.825,5.5,21.662,5.5,21.5v-8.207c0.12,0.109,0.257,0.216,0.387,0.324c0.072,0.06,0.139,0.12,0.215,0.18c0.3,0.236,0.624,0.469,0.975,0.696c0.073,0.047,0.155,0.093,0.231,0.14c0.294,0.183,0.605,0.362,0.932,0.538c0.121,0.065,0.242,0.129,0.367,0.193c0.365,0.186,0.748,0.366,1.151,0.542c0.066,0.029,0.126,0.059,0.193,0.087c0.469,0.199,0.967,0.389,1.485,0.572c0.143,0.051,0.293,0.099,0.44,0.149c0.412,0.139,0.838,0.272,1.279,0.401c0.159,0.046,0.315,0.094,0.478,0.139c0.585,0.162,1.189,0.316,1.823,0.458c0.087,0.02,0.181,0.037,0.269,0.056c0.559,0.122,1.139,0.235,1.735,0.34c0.202,0.036,0.407,0.07,0.613,0.104c0.567,0.093,1.151,0.179,1.75,0.257c0.154,0.02,0.301,0.042,0.457,0.062c0.744,0.09,1.514,0.167,2.305,0.233c0.195,0.016,0.398,0.028,0.596,0.042c0.633,0.046,1.28,0.084,1.942,0.114c0.241,0.011,0.481,0.022,0.727,0.03C26.712,18.979,27.59,19,28.5,19s1.788-0.021,2.65-0.05c0.245-0.008,0.485-0.02,0.727-0.03c0.662-0.03,1.309-0.068,1.942-0.114c0.198-0.015,0.4-0.026,0.596-0.042c0.791-0.065,1.561-0.143,2.305-0.233c0.156-0.019,0.303-0.042,0.457-0.062c0.599-0.078,1.182-0.164,1.75-0.257c0.206-0.034,0.411-0.068,0.613-0.104c0.596-0.105,1.176-0.218,1.735-0.34c0.088-0.019,0.182-0.036,0.269-0.056c0.634-0.142,1.238-0.296,1.823-0.458c0.163-0.045,0.319-0.092,0.478-0.139c0.441-0.128,0.867-0.262,1.279-0.401c0.147-0.05,0.297-0.098,0.44-0.149c0.518-0.184,1.017-0.374,1.485-0.572c0.067-0.028,0.127-0.059,0.193-0.087c0.403-0.176,0.786-0.356,1.151-0.542c0.125-0.064,0.247-0.128,0.367-0.193c0.327-0.175,0.638-0.354,0.932-0.538c0.076-0.047,0.158-0.093,0.231-0.14c0.351-0.227,0.675-0.459,0.975-0.696c0.075-0.06,0.142-0.12,0.215-0.18C51.243,13.509,51.38,13.402,51.5,13.293z M28.5,2c13.554,0,23,3.952,23,7.5s-9.446,7.5-23,7.5s-23-3.952-23-7.5S14.946,2,28.5,2z"
                      />
                    </svg>
                  </div>
                  <div class="txt">기업 인증</div>
                </v-btn>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else>
        <v-row no-gutters class="myLock_inTxt">
          <v-col cols="12">
            <v-img></v-img>
          </v-col>
          <v-col cols="12">
            <ul class="pattern_ul_terms ta_left">
              <li>
                기업 인증은
                <font class="fc_b00">기업이 존재하는 사용자를 위한</font>
                기능입니다. 만약 기업이 존재한다면 기업을 선택 후 해당 기능을
                이용바랍니다.
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <pubCert
      ref="pubCert"
      :cert-regno="orgInfo ? orgInfo.organizationRegistrationNumber : ''"
      @childs-event="purCertResult"
    ></pubCert>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>
<script>
import { getTempOrgInfo, auth } from "@/api/orgconfig";
import pubCert from "@/components/pubCertCompany";

export default {
  name: "auth",
  components: {
    pubCert
  },
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      orgInfo: null,
      valid: false,
      rules: {
        passwordRules: [
          v => !!v || "블록체인 비밀번호를 입력해 주세요",
          v =>
            /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) ||
            "영어, 숫자 포함하여 6~12자리로 입력해 주십시요"
        ],
        comfirmPasswordRule: [
          v => !!v || "블록체인 비밀번호를 입력해 주세요",
          v =>
            this.chainPass === v ||
            "블록체인 비밀번호와 입력한 비밀번호가 다릅니다."
        ]
      },
      chainPass: null,
      comfirmChainPass: null
    };
  },
  created() {},
  mounted() {
    this.$refs.loading.start(
      "인증할 기업정보를 세팅 중입니다. 잠시만 기다려주세요."
    );
    getTempOrgInfo()
      .then(response => {
        this.$refs.loading.end();
        if (response.rcode === 20000 && response.rdata.success) {
          this.orgInfo = response.rdata.org;
        } else {
          this.$refs.confirm
            .open(
              "alert",
              "기업정보 조회",
              "기업정보 조회에 실패했습니다. (ERR : " +
                response.rdata.message +
                ")"
            )
            .then(() => {
              if (process.env.NODE_ENV === "development") {
                window.location = "http://localhost:8088/main";
              } else {
                window.location = process.env.VUE_APP_REQUEST_URL + "/main";
              }
            });
        }
      })
      .catch(() => {
        this.$refs.loading.end();
        this.$refs.confirm.open(
          "alert",
          "기업정보 조회",
          "기업정보 조회에 실패했습니다. 관리자에게 문의해주세요."
        );
      });
  },
  methods: {
    certificate() {
      if (this.$refs.passwordForm.validate()) {
        this.$refs.pubCert.open();

        /* // 테스트
        let result = {
          certPEM: "certPEM",
          rValue: "rValue",
          signValue: "signValue",
          hashValue: "hashValue",
          username: "(주)비즈니스온커뮤니케이션"
        }; 
        this.purCertResult(result);*/
      } else {
        this.$refs.confirm.open(
          "alert",
          "기업인증",
          "블록체인 비밀번호를 제대로 입력해주세요."
        );
      }
    },
    purCertResult(result) {
      this.$refs.loading.start("기업인증 중입니다. 잠시만 기다려주세요.");
      auth({
        chainPass: this.chainPass,
        pubkey: result.certPEM,
        rValue: result.rValue,
        signValue: result.signValue,
        hashValue: result.hashValue,
        companyName: result.username
      })
        .then(response => {
          this.$refs.loading.end();
          if (response.rcode === 20000 && response.rdata.success) {
            this.$refs.confirm
              .open("alert", "기업인증", "기업인증이 완료되었습니다.")
              .then(() => {
                if (process.env.NODE_ENV === "development") {
                  window.location = "http://localhost:8088/main";
                } else {
                  window.location = process.env.VUE_APP_REQUEST_URL + "/main";
                }
              });
          } else {
            this.$refs.confirm
              .open(
                "alert",
                "기업인증",
                "기업인증에 실패했습니다. (ERR : " +
                  response.rdata.message +
                  ")"
              )
              .then(() => {
                if (process.env.NODE_ENV === "development") {
                  window.location = "http://localhost:8088/main";
                } else {
                  window.location = process.env.VUE_APP_REQUEST_URL + "/main";
                }
              });
          }
        })
        .catch(() => {
          this.$refs.loading.end();
          this.$refs.confirm.open(
            "alert",
            "기업인증",
            "기업인증에 실패했습니다."
          );
        });
    }
  }
};
</script>
<style scoped>
.auth_box {
  width: 100%;
  height: 300px;
  position: absolute;
  left: 30%;
  top: 30%;
  margin-left: -150px;
  margin-top: -150px;
}
</style>
